export const ROLES = {
  RECEPTIONIST: "receptionist",
  PRE_OPD_MANAGEMENT: "pre_opd_management",
  DOCTOR: "doctor",
  FOLLOW_UP_MANAGEMENT: "follow_up_management",
  COUNSELLOR: "counsellor",
  NURSE: "nurse",
  IPD_MANAGEMENT: "ipd_manager",
  PHARMACIST: "pharmacist",
  RADIOLOGIST: "radiologist",
  LAB_TEST: "lab_technician",
  THERAPIST: "therapist",
  YOGA: "yoga_instructor",
  BILLING_MANAGER: "billing_manager",
  DIETICIAN: "dietician",
  STAFF_MANAGER: "staff_manager",
  STORE_MANAGER: "store_manager",
  LOGISTICS: "logistics",
  ADMIN: "admin",
};
